module.exports = function() {
  return JSON.stringify(this.customQueries);
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/computed/custom-q.js